  <div class="w-full h-full flex flex-col">
    <div class="flex-grow min-h-0 w-full">
      @if(pinnedImages.length==0 && notPinnedImages.length==0){
        <p class="pl-5">{{ 'DocumentList.NoImages'|translate }}</p>
      } @else {
      <app-greedy-scroll-panel>
        <div class="grid grid-cols-2 gap-2 items-center pb-4">
          @if (pinnedImages.length > 0) {
            <div class="flex items-center col-span-2">
              <span class="material-symbols-outlined !text-xl">keep</span>
              {{ pinnedTranslationKey|translate }}
            </div>
          }
          @for (pinnedImage of pinnedImages; track pinnedImage.id) {
            <div class="flex flex-col w-full">
              <div class="text-center overflow-hidden">
                {{ pinnedImage.filename }}
              </div>
              <div class="imageContainer">
                <img class="max-w-[100%] max-h-[100%]"
                     [src]="'data:'+pinnedImage.mimeType+';base64,'+pinnedImage.thumbailBase64Data"/>
                <div class="imageContainerCenterIcon">
                  <i class="pi pi-eye text-center text-white clickable" style="font-size: 24px"
                     (click)="openViewDocumentDialog(pinnedImage.id)"></i>
                </div>
                @if (!pinLock) {
                <div class="imageContainerTopLeftIcon" (click)="unpinDocument(pinnedImage)">
                  <span class="material-symbols-outlined text-white clickable">keep_off</span>
                </div>
                }
                <div class="imageContainerBottomLeftIcon">
                  <i class="material-symbols-outlined text-white clickable"
                     (click)="openEditDocumentPage(pinnedImage)">edit</i>
                </div>
                @if (!deletePinnedLock) {
                <div class="imageContainerTopRightIcon">
                  <i class="material-symbols-outlined text-red-600 clickable"
                     (click)="openDeleteDocumentDialog(pinnedImage)">delete</i>
                </div>
                }
                @if (pinnedImage.hasAnnotation) {
                  <div class="imageContainerBottomRightIcon">
                    <i class="material-symbols-outlined text-white">format_ink_highlighter</i>
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="grid grid-cols-2 gap-2 items-center mt-6">
          @for (image of notPinnedImages; track image.id) {
            <div class="flex flex-col w-full">
              <div class="text-center overflow-hidden">
                {{ image.filename }}
              </div>
              <div class="imageContainer">
                <img class="max-w-[100%] max-h-[100%]"
                     [src]="'data:'+image.mimeType+';base64,'+image.thumbailBase64Data"/>
                <div class="imageContainerCenterIcon">
                  <i class="pi pi-eye text-center text-white clickable" style="font-size: 24px"
                     (click)="openViewDocumentDialog(image.id)"></i>
                </div>
                @if (!pinLock) {
                <div class="imageContainerTopLeftIcon" (click)="pinDocument(image)">
                  <span class="material-symbols-outlined text-white clickable">keep</span>
                </div>
                }
                <div class="imageContainerBottomLeftIcon">
                  <i class="material-symbols-outlined text-white clickable"
                     (click)="openEditDocumentPage(image)">edit</i>
                </div>
                <div class="imageContainerTopRightIcon">
                  <i class="material-symbols-outlined text-red-600 clickable"
                     (click)="openDeleteDocumentDialog(image)">delete</i>
                </div>
                @if (image.hasAnnotation) {
                  <div class="imageContainerBottomRightIcon">
                    <i class="material-symbols-outlined text-white">format_ink_highlighter</i>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </app-greedy-scroll-panel>
      }
    </div>
  </div>
